export default "__VITE_ASSET__wzOi44o6__"